(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hoohla-club-carousel"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root) => {
      const track = root.querySelector('.hoohla-club-library__track');
      const controls = root.querySelector('.hoohla-club-library__controls');
      if (!track || !controls || root.dataset.carouselReady) return;
      root.dataset.carouselReady = 'true';
      const previous = controls.querySelector('[data-club-previous]');
      const next = controls.querySelector('[data-club-next]');
      const update = () => {
        const end = Math.max(0, track.scrollWidth - track.clientWidth);
        controls.hidden = end < 2;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= end - 2;
      };
      const move = (direction) => {
        const card = track.firstElementChild;
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(track);
      update();
    };
    const initializeAll = () => document.querySelectorAll('.hoohla-club-library').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
